export function normalCdf(x) {
    const t = 1 / (1 + 0.2316419 * x)
    // coefficients for approximation
    const a1 = 0.319381530, a2 = -0.356563782, a3 = 1.781477937, a4 = -1.821255978, a5 = 1.330274429
    const pdf = Math.exp(-0.5 * x * x) / Math.sqrt(2 * Math.PI)
    const poly = ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t
    return 1 - pdf * poly
}
